import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';

function ResetPasswordPage() {
    const { uid, token } = useParams();
    console.log(uid);
    console.log(token);

    const navigate = useNavigate();

    // State management
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    // Password validation regex (at least 8 characters, 1 letter, 1 number)
    const passwordValidation = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/;
    const buttonClass = `p-2  
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center
                      rounded-full shadow-md transition`
    const fieldClass = "w-full bg-tertiary-400 m-1 p-2 text-sm font-nunito placeholder:text-gray-500 rounded"
    const redirectToLogin = () => {
            navigate('/login');
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(password)
        // Validate password
        if (!passwordValidation.test(password)) {
        setMessage("Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.");
        return;
        }

        if (password !== rePassword) {
        setMessage("Passwords do not match.");
        return;
        }

        setMessage('');
        setLoading(true);
        setIsButtonDisabled(true);

        try {
        await axios.post('/auth/users/reset_password_confirm/', {
            uid,
            token,
            new_password: password,
        });
        setMessage('✅ Password reset successful! You can now log in with your new password.');
        setStatus('Success')
        
        } catch (err) {
            setStatus('Error')
            console.log(err);
            if (err.response && err.response.data) {
                const errorResponseDataArray = Object.entries(err.response.data);
                console.log(errorResponseDataArray[0][1])
                 if (errorResponseDataArray) {
                    const errorMessage = errorResponseDataArray[0][1];
                    console.log(errorMessage)
                    setMessage(errorMessage);
                } else {
                    setMessage(err.response.data);
                }
            } else if (err.request && err.request.responseText) {
              console.log(err.request.responseText.split(":")[1])
              const errorData = err.request.responseText;
              setMessage(errorData);
            }
            else {
                setMessage(err.message);
            }
        } finally {
        setLoading(false);
        setIsButtonDisabled(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-primary-100 rounded shadow-md">
            <div className="max-w-md m-auto p-6 bg-tertiary-600 rounded shadow-md">
            <h2 className="text-2xl font-semibold text-center mb-4">Reset Password</h2>
            
            <form onSubmit={handleSubmit} aria-labelledby="reset-password-form">
                <div className="mb-4">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">New Password</label>
                <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Enter your new password"
                    required
                    aria-describedby="passwordHelp"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`${fieldClass}`}
                />
                <p id="passwordHelp" className="text-xs text-gray-500 mt-1">
                    Password must be at least 8 characters long, with one capital Letter, number and a speacial character.</p>
                </div>
                <div className="mb-6">
                <label htmlFor="rePassword" className="block text-sm font-medium text-gray-700">Confirm Password</label>
                <input
                    type="password"
                    id="rePassword"
                    name="rePassword"
                    placeholder="Confirm your new password"
                    required
                    value={rePassword}
                    onChange={(e) => setRePassword(e.target.value)}
                    className={`${fieldClass}`}
                />
                </div>
                {message && (
                    <>
                    {status === 'Error' && <p className="text-center text-danger-500">❌ Password Reset Failed</p>}
                    <p className="text-center mb-4 text-danger-500">{message}</p>
                    </>
                    )}
                {status === 'Success' ? ( 
                    <div className="mb-6 justify-center">
                        <button
                        data-cy="loginnow"
                        type="button"
                        onClick = {redirectToLogin}
                        className={`w-full ${buttonClass} rounded-md ${isButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={isButtonDisabled}
                        >
                        {loading ? 'Resetting...' : 'Login Now'}
                        </button>
                    </div>
                ) : (
                <div className="mb-6 justify-center">
                    <button
                    type="submit"
                    className={`w-full ${buttonClass} rounded-md ${isButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={isButtonDisabled}
                    >
                    {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </div>
                )}
            </form>
            </div>
        </div>
    );
}

export default ResetPasswordPage;
